import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { ISRResponse } from '_core/types';
import { MemberTypes } from '../Types';

const machine = Machines.onUpdateMember.machine;

export const updateMember = (
  params: MemberTypes.IUpdateMemberServiceRequest,
): Promise<ISRResponse> => {
  return callServiceMachine(machine, params);
};

export default { updateMember };
